import React, { useCallback } from 'react'
import styled, { StyledProps } from 'styled-components'
import { Button, ButtonFullProps } from '../Button/Button'
import { useTranslation } from 'react-i18next'
import { Link, LinkProps } from 'react-router-dom'
import { helpersColor } from '../../../helpers'
import { IconPlusCircle } from '../../iconography/Icons/Icons'

const IconStyled = styled(IconPlusCircle)<StyledProps<{}>>`
  color: ${({ theme }: StyledProps<{}>) => theme.color.accentApproving};
  transition: 0.1s color ease-out;

  button:hover & {
    color: ${({ theme }: StyledProps<{}>) => helpersColor.alphaColor(theme.color.accentApproving, 0.75)};
  }
`

export type AddButtonProps = Omit<ButtonFullProps, 'intent' | 'size'> & {
  to?: LinkProps['to']
  text?: string
  noText?: boolean
  className?: string
}

export const AddButton: React.FC<AddButtonProps> = ({ to, text, noText, className, onClick, ...props }) => {
  const { t } = useTranslation('ui')
  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      onClick && onClick(e)
    },
    [onClick],
  )

  if (to) {
    return (
      <Link to={to} onClick={handleClick} className={className}>
        <Button intent={'action'} filled size={'small'} className={className} {...props}>
          <IconStyled data-no-text={noText} />
          {!noText ? text || t('common.add') : null}
        </Button>
      </Link>
    )
  }

  return (
    <Button intent={'action'} filled={true} size={'small'} className={className} onClick={handleClick} {...props}>
      <IconStyled data-no-text={noText} />
      {!noText ? text || t('common.add') : null}
    </Button>
  )
}
